import { prependAql } from '../utils/aqlStringUtils'
import { HASWORDS_AQL_PATTERN } from '../../regexp'
import type { AllDashboardCardFilters } from '../../types'

export const parseHasWords = (aql: string): Pick<AllDashboardCardFilters, 'hasWords'> => {
    const regex = new RegExp(HASWORDS_AQL_PATTERN, 'i')
    const match = regex.exec(aql)

    return match ? { hasWords: match[0] } : { hasWords: '' }
}

export const updateHasWords = (prior = '', value = ''): string => {
    const regex = new RegExp(HASWORDS_AQL_PATTERN, 'i')
    const priorFound = regex.test(prior)
    const strippedQuotes = value.replace(/"/g, '')

    return priorFound ? prior.replace(regex, strippedQuotes) : prependAql(prior, '', strippedQuotes)
}
